import { FormTypes } from '@oneblink/types'
import { findElement, replaceElement } from '../../definition-manipulation'

type FacilityItem = {
  facilityName: string
  facilityType: string
  price: number
  gstApplied: boolean
}

function licenceChargesTable({
  facilities,
  payableAmount,
  applicationFee,
}: {
  facilities?: FacilityItem[]
  payableAmount?: number
  applicationFee?: number
}) {
  if (!facilities) {
    return `
      <b>
        <i>No payment is required for this application - please proceed to submission</i>
      </b>
      `
  }

  if (payableAmount === undefined) {
    return ''
  }

  let tableHtml = `
  <div class="fa-charges-table__container">
    <table class="fa-charges-table">
      <tr class="fa-charges-table__header">
        <td></td>
        <td>Fees</td>
      </tr>`

  if (Array.isArray(facilities)) {
    tableHtml += facilities.reduce((html, facility) => {
      html += `
      <tr class="fa-charges-table__row">
        <td class="fa-charges-table__row-label">${facility.facilityName}</td>
        <td class="fa-charges-table__row-value">$${facility.price.toFixed(
          2,
        )}</td>
      </tr>
    `
      return html
    }, '')
  }

  if (applicationFee !== undefined && !Number.isNaN(applicationFee)) {
    tableHtml += `
    <tr class="fa-charges-table__row">
      <td class="fa-charges-table__row-label">Application fee</td>
      <td class="fa-charges-table__row-value">$${applicationFee.toFixed(2)}</td>
    </tr>
    `
  }

  tableHtml += `
    <tr class="fa-charges-table__row fa-charges-table__total-payable-row">
      <td class="fa-charges-table__row-label">TOTAL PAYABLE NOW</td>
      <td class="fa-charges-table__row-value">$${payableAmount.toFixed(2)}</td>
    </tr>
  </table>
  `

  return tableHtml
}

export default function generateLicenceChargesTable(
  submission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  // Charges payable now table logic
  const existingChargesPayableNowElement = findElement<FormTypes.HtmlElement>(
    definition,
    'licenceChargesPayableNow',
  )

  if (existingChargesPayableNowElement) {
    const facilities = submission.facilities__hidden as
      | FacilityItem[]
      | undefined

    const chargesPayableTable = licenceChargesTable({
      facilities,
      payableAmount: submission.paymentTotal__hidden as number,
      applicationFee: submission.applicationFee__hidden as number,
    })

    const chargesPayableNowElement = {
      ...existingChargesPayableNowElement.value,
      defaultValue: chargesPayableTable,
    }

    existingChargesPayableNowElement.parent.elements = replaceElement(
      existingChargesPayableNowElement.parent.elements || [],
      existingChargesPayableNowElement.value,
      chargesPayableNowElement,
    )
  } else {
    console.warn(
      `Unable to display charges payable now table as 'licenceChargesPayableNow' element does not exist`,
    )
  }

  return definition
}
